import * as types from '../actions/actionTypes';

const initialState = {
    keyword: '',
    newCampaignList: {
        loading: false,
        success: true,
        message: '',
        campaignListId: ''
    },
    allCampaignLists: {
        loading: false,
        success: true,
        data: []
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_CAMPAIGN_LISTS_FILTERS:
            return Object.assign({}, state, { filters: { ...state.filters, ...action.update } });

        case types.START_CREATE_CAMPAIGN_LIST:
            return Object.assign({}, state, { newCampaignList: { ...state.newCampaignList, loading: true } });
        case types.CREATE_CAMPAIGN_LIST:
            return Object.assign({}, state, {
                newCampaignList:
                    { loading: action.response.loading, success: action.response.success, message: action.response.message, campaignListId: action.response.data }
            });

        case types.UPDATE_CAMPAIGN_LISTS_SEARCH:
            return Object.assign({}, state, { keyword: action.keyword });

        case types.START_GET_CAMPAIGN_LISTS:
            return Object.assign({}, state, { allCampaignLists: { ...state.allCampaignLists, loading: true } });
        case types.GET_CAMPAIGN_LISTS:
            return Object.assign({}, state, { allCampaignLists: action.response });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/CampaignListsReducer.js